var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-container',[_c('el-main',[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.$router.push('/codeSearch')}}},[_vm._v("行政复议网上申请")]),_c('el-button',{attrs:{"type":"success"},on:{"click":function($event){return _vm.$router.push('/documentsList')}}},[_vm._v("行政复议文书公开")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }